<template>
  <transition name="modal" mode="out-in">
    <section class="modal-container" v-if="isDisplayed.display">
      <div class="modal-content">
        <button
          v-if="isDisplayed.isGranted"
          class="modal-button"
          @click="closeModal(true)"
        >PROCEED TO NEXT STORY</button>
        <h1 v-if="!isDisplayed.isGranted">{{ isDisplayed.deniedReason }}</h1>
        <span v-if="!isDisplayed.isGranted" class="modal-btn-flex">
          <button class="modal-button" @click="closeModal(false)">GO BACK TO THE CURRENT PART</button>
        </span>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: "Access-Modal",
  data() {
    return {};
  },
  computed: {
    isDisplayed() {
      return this.$store.state.isModalDisplayed;
    }
  },
  methods: {
    closeModal(condition) {
      if (condition) {
        this.$router.push(this.isDisplayed.url);
        this.$store.commit("setModalDisplay", {
          display: false,
          isGranted: false,
          deniedReason: "",
          url: ""
        });
      } else {
        this.$store.commit("setModalDisplay", {
          display: false,
          isGranted: false,
          deniedReason: "",
          url: ""
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/Scheme.scss";
.modal-container {
  font-family: $font_first;
  position: fixed;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  right: 0;
  height: 100%;
  width: 50%;
  background-color: $color_black;
  .modal-content {
    letter-spacing: 0.5px;
    font-size: 1em;
    margin-left: 1.5em;
    h1 {
      margin: 0;
      font-weight: 400;
    }
    .modal-btn-flex {
      display: flex;
      justify-content: left;
      margin-top: 1.5vh;
    }
    @media screen and (max-width: 400px) {
      font-size: 0.3em;
    }
  }
}
.modal-button {
  margin-top: 1em;
  cursor: pointer;
  font-size: 0.75em;
  padding: 6px 12px;
  border-radius: 2px;
  border: 2px solid white;
  background-color: $color_black;
  color: white;
  font-weight: 700;
  transition: all 0.2s;
  &:hover {
    color: $color_black;
    background-color: white;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s ease-out;
}
.modal-enter {
  transform: translate(100%, 0);
}
.modal-leave-to {
  transform: translate(100%, 0);
}
</style>
